'use strict'

var Marionette = require('marionette')
var App = require('app')
var DialogComponent = require('src/components/dialog-view')

// -- Dialog Body ---------------------------
var dialogBody = DialogComponent.Body.extend({
  template: require('./templates/body.html'),
  triggers: {
    'click .js-send-new-password': 'send-new-password'
  },
  templateContext: function () {
    return {
      getDeviceTypes: App.TemplateHelpers.getDeviceTypes,
      getClients: App.TemplateHelpers.getClients,
      getUserRoles: App.TemplateHelpers.getUserRoles,
      userHasRole: App.TemplateHelpers.userHasRole
    }
  }
})

// -- Dialog Layout ---------------------------
var dialogView = DialogComponent.Layout.extend({
  className: 'dialog dialog-user',
  onRender: function () {
    var bodyView = new dialogBody({model: this.model, collection: this.collection})
    this.showChildView('bodyRegion', bodyView)
  }
})

module.exports.layout = dialogView



// WEBPACK FOOTER //
// ./js/modules/client-users/edit_new/view.js